<script setup>
// Club-page cell for a Meet (equivalent of LeagueClickableCell etc.):
// "Meet · every Wednesday · £6.50" from the MeetListResponse.
import {computed} from 'vue';
import ClickableCell from '@/components/lists/ClickableCell';
import {useMeetFormat} from '~/composables/useMeetFormat';

const props = defineProps({
  meet: {
    type: Object,
    default: () => null
  }
});

const {recurrenceText, isPaid, feeText} = useMeetFormat();

const subtitle = computed(() => {
  const parts = [`Meet · ${recurrenceText(props.meet)}`];
  parts.push(isPaid(props.meet) ? feeText(props.meet) : 'free');
  if (props.meet.playerCount != null) parts.push(`${props.meet.playerCount} players`);
  return parts.join(' · ');
});
</script>

<template>
  <clickable-cell
      icon="mdi-handshake"
      tone="meet"
      class="mb-3"
      :to="{ name: 'MeetDetail', params: { meetId: meet.id } }"
      :title="meet.name"
      :subtitle="subtitle"
  />
</template>
